import React, { useEffect, useState } from 'react';
import DataTable from '../../../components/DataTable/DataTable';
import { IColInfo } from '../../../components/DataTable/Interfaces';
import { ApplicationFunctions, useAuth } from '../../../contexts/authContext';
import { useNotifications } from '../../../contexts/notificationContext';
import MilestoneDefinitionModel from '../../../models/MilestoneDefinitionModel';
import DataService from "../../../services/data.service";
import CreateMilestoneDefinitionPopup from '../Popups/ProjectType_popup_CreateMilestoneDefinition';

interface Props {
    projectTypeId: number
}

const ProjectType_tab_Milestones: React.FC<Props> = ({ projectTypeId }) => {
    const [data, setData] = useState<MilestoneDefinitionModel[]>();
    const [showPopup, setShowPopup] = useState<boolean>(false)
    const { handleResult, handleException } = useNotifications();
    const { isAuthorizedForProjectType } = useAuth();

    useEffect(() => {
        getTableData();
    }, [projectTypeId]);

    function getTableData() {
        DataService.get<MilestoneDefinitionModel[]>('api/v1/MilestoneDefinitions/ByProjectType/' + projectTypeId)
            .then(response => {
                setData(response);
            })
            .catch(e => { handleException(e); });
    }

    function deleteRow(rowData: MilestoneDefinitionModel) {
        DataService.delete('api/v1/MilestoneDefinitions/', rowData.id)
            .then(response => {
                handleResult(response);
                getTableData();
            })
            .catch(e => { handleException(e); });
    }

    let colInfos: IColInfo[] = [
        { key: true, dataProp: 'id', visible: false },
        { title: 'Name', dataProp: 'name' },
        { title: 'Type', dataProp: 'milestoneType.name' },
        { title: 'Attachment type', dataProp: 'attachmentType.name' },
        { title: 'Days to Achieve', dataProp: 'daysToAchieve', dataType: 'number', sort: 'asc' },
        { title: 'Later after', dataProp: 'lateDays', dataType: 'number' },
        { title: 'Missed aFter', dataProp: 'missedDays', dataType: 'number' },
    ];

    if (isAuthorizedForProjectType(ApplicationFunctions.EditProjectType, projectTypeId)) 
        colInfos.push(
            {
                headerButtons: [{ text: "Add", icon: 'fa-plus-square', color: '#26A69A', onClick: () => setShowPopup(true) }],
                rowButtons: [{ text: "Delete", icon: 'fa-trash', color: '#F3565D', onClick: deleteRow }]
            });

    return (
        <>
            <DataTable
                name='dtProjectTypeMilestones'
                colInfos={colInfos}
                tableData={data}
                navigateTitle='Milestone'
                navigateUrl='/plm/WorkflowSetup/MilestoneDefinition/'
            />
            {showPopup && <CreateMilestoneDefinitionPopup show={showPopup} onHide={() => { setShowPopup(false); getTableData(); }} projectTypeId={projectTypeId} />}
        </>
    );
}
export default ProjectType_tab_Milestones;

